import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Modal from '@mos-cat/modal';

import Button from '../../components/Button/Button';
import Content from '../../components/Content/Content';
import { isShowError } from '../../constants/isDev';

import {
  hideRequestError,
  retryGetUserData
} from '../../store/requestError/actions';
import {
  visibleRequestErrorSelector,
  typeErrorRequestSelector,
  requestCausedErrorSelector
} from '../../store/requestError/selectors';

import ErrorSendAppeal from './ErrorSendAppeal';
import RequestAppealAlreadyReported from './RequestAppealAlreadyReported';

import './RequestError.pcss';

// typograf-enable
class RequestError extends PureComponent {
  render() {
    const {
      visible,
      typeError,
      requestCausedError,
      hideRequestError,
      retryGetUserData
    } = this.props;

    if (!visible) {
      return null;
    }

    if (isShowError === false) {
      return null;
    }

    const handleCancel = () => {
      hideRequestError();
      document.body.classList.remove('body_overflow-hidden');
    };

    // показ ошибки отправки запроса на апелляцию
    if (typeError === 'ErrorSendAppeal') {
      return (
        <Modal visible onCancel={handleCancel}>
          <div className="ModalError" />
          <ErrorSendAppeal onHideRequestError={handleCancel} />
        </Modal>
      );
    }

    // показ ошибки отправки запроса на апелляцию
    if (typeError === 'RequestAppealAlreadyReported') {
      return (
        <Modal visible onCancel={handleCancel}>
          <div className="ModalError" />
          <RequestAppealAlreadyReported
            requestCausedError={requestCausedError}
            onHideRequestError={handleCancel}
          />
        </Modal>
      );
    }

    const retry = () => {
      retryGetUserData();
      document.body.classList.remove('body_overflow-hidden');
    };

    return (
      <Modal visible onCancel={handleCancel} className="RequestError">
        <div className="RequestError__icon" />
        <Content>
          <Content.Title>Услуга недоступна</Content.Title>
          <Content.Text>
            При выполнении запроса произошла ошибка. Пожалуйста, повторите
            попытку позже
            {typeError === 'ErrorGetUserData' && (
              <>
                {' '}
                или
                <Button type="inline-link" onClick={retry}>
                  {' '}
                  попробуйте еще раз сейчас
                </Button>
              </>
            )}
            .
          </Content.Text>
          <Content.Button>
            <Button
              primary
              onClick={() => {
                handleCancel();
                window.scrollTo(0, 0);
              }}
            >
              Закрыть
            </Button>
          </Content.Button>
        </Content>
      </Modal>
    );
  }
}

RequestError.propTypes = {
  visible: PropTypes.bool,
  typeError: PropTypes.string,
  requestCausedError: PropTypes.string,
  retryGetUserData: PropTypes.func,
  hideRequestError: PropTypes.func.isRequired
};

RequestError.defaultProps = {
  visible: false,
  typeError: null,
  requestCausedError: null
};

const mapStateToProps = state => ({
  visible: visibleRequestErrorSelector(state),
  typeError: typeErrorRequestSelector(state),
  requestCausedError: requestCausedErrorSelector(state)
});

export default connect(mapStateToProps, dispatch =>
  bindActionCreators(
    {
      hideRequestError,
      retryGetUserData
    },
    dispatch
  )
)(RequestError);
